export default __webpack_public_path__ + "static/media/Boton_1.b3768161.png";